
import React from "react";
import { PartSubcategory } from "@/data/parts";

interface SubcategoryCellProps {
  subcategory: PartSubcategory;
  onClick: (subcategory: PartSubcategory) => void;
}

const SubcategoryCell = ({ subcategory, onClick }: SubcategoryCellProps) => {
  return (
    <span 
      className="cursor-pointer hover:text-primary"
      onClick={() => onClick(subcategory)}
    >
      {subcategory}
    </span>
  );
};

export default SubcategoryCell;
